<template>
  <div>
    <!-- Escalation point block -->
    <div class="card">
      <div class="card-body" id="update_escalation_point" :class="{'pr-0 pl-0': showOnTask}">
        <div class="float-right btn-sm btn-edit mr-0"
             @click="showFormFunction"
             qid="processing-role-edit-button"
             v-if="!showForm && isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
        >
          <font-awesome-icon icon="pen"/>
        </div>
        <div class="mb-2">
          <h5 class="h5" v-if="!showOnTask">
            {{ $t('maintenance.incidents.incident_categories.escalation.title') }}
          </h5>
          <div v-if="getGuide('update_escalation_point')" class="mb-2">
            <GuideButton :guide="getGuide('update_escalation_point')"></GuideButton>
          </div>
          <small class="text-bold text-muted">
            {{ $t('maintenance.incidents.incident_categories.escalation.description') }}
          </small>
        </div>

        <div class="mw-600" v-if="showForm">
          <div>
            <label for="">
              {{ $t('maintenance.incidents.incident_categories.responsibles.organization_label') }}
            </label>
            <multiselect
                v-model="selectedOrganization"
                :options="organizations"
                @search-change="loadOrganizations"
                select-label="✔"
                selected-label="✔"
                deselect-label="x"
                track-by="slug"
                :placeholder="$t('maintenance.incidents.incident_categories.responsibles.organization_label')"
                label="name"
                qid="create-p-users-select"
            ></multiselect>
          </div>
          <div class="mt-3">
            <label for="">
              {{ $t('maintenance.incidents.incident_categories.responsibles.responsibles_label') }}
            </label>
            <multiselect
                v-model="selectedUsers"
                :options="users"
                :multiple="true"
                :taggable="false"
                @search-change="loadUsers"
                select-label="✔"
                selected-label="✔"
                deselect-label="x"
                track-by="slug"
                :placeholder="$t('maintenance.incidents.incident_categories.responsibles.responsibles_label')"
                label="name"
                qid="create-p-users-select"
            >
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </div>
          <div class="text-right mt-3">
            <b-button class="ml-3"
                      variant="secondary"
                      @click="cancelForm"
                      qid="edit-pr-cancel-button"
            >
              {{ $t('activities.processing_type.cancel') }}
            </b-button>
            <b-button class="ml-2"
                      variant="success"
                      @click="formSubmit"
                      qid="edit-pr-submit-button"
            >
              {{ $t('activities.processing_type.submit') }}
            </b-button>
          </div>
        </div>
        <div v-if="!showForm">
          <div v-if="incident" class="mt-2">
            <label for="">
              {{ $t('maintenance.incidents.incident_categories.responsibles.organization_label') }}
            </label>
            <div class="section-container">
              <span v-if="incident && incident.escalation_department && incident.escalation_department.id">
                {{ incident.escalation_department.name }}
              </span>
              <p v-if="!incident.escalation_department" class="text-muted">
                {{ $t('system.missing_input') }}
              </p>
            </div>
            <br>
            <label for="">
              {{ $t('maintenance.incidents.incident_categories.responsibles.responsibles_label') }}
            </label>
            <div class="section-container" v-if="incident.task_users && incident.task_users.length">
              <span class="mr-1" v-for="user in incident.task_users" qid="activity-task_users-list">
                <Avatar :object="user" size="xs"></Avatar>
              </span>
            </div>
            <div class="section-container" v-if="incident.task_users && !incident.task_users.length">
              <p class="text-muted">
                {{ $t('system.missing_input') }}
              </p>
            </div>
          </div>
        </div>
        <div>
          &nbsp;
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import {config} from '@/config.js'
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'Escalation',
    data: function() {
      return {
        incident: {},
        descriptionLength: config.descriptionLength,
        showFullDescription: false,
        showDescriptionInput: false,
        showPurposeInput: false,
        incidentEditDescription: '',
        showForm: false,
        anonymousCreator: '',
        selectedOrganization: [],
        organizations: [],
        selectedUsers: [],
        users: [],

        error: '',
        myGuides: [],
        myTasks: [],
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        form: {
          task_users: [],
          escalation_department_id: ''
        }
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      submitForm: {},
      task: {}
    },
    components: {
      Avatar,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.incident.id && this.$store.state.updatedObject.who_am_i == this.incident.who_am_i) {
              this.incident = this.$store.state.updatedObject
            }
          }
          this.loadContent()
        }
      },
      // Watch when client changes in store and trigger api reload
      getClient: function (newValue, oldValue) {
        this.loadOrganizations()
        this.loadUsers()
      },
      object: function (value) {
        this.incident = value

        if (this.showOnTask && !this.incident.description) {
          this.incidentEditDescription = ''
          this.showDescriptionInput = true;
        }

        if (this.showOnTask && this.incident.description) {
          this.showDescriptionInput = false;
        }
      },
      submitForm: function (value) {
        if (value) {
          if (this.showDescriptionInput) {
            this.formSubmit()
          }
        }
      }
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadContent()
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.incident.who_am_i,
              model_id: this.incident.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'incident_categories.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Incident' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: language,
            type: 'Incident',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showFormFunction() {
        this.showForm = true;
        let self = this;
        this.loadOrganizations()
        this.loadUsers()

        this.selectedUsers = [];
        _.forEach(this.incident.task_users, function (user) {
            self.selectedUsers.push(user)
        })

        this.selectedOrganization = this.incident.escalation_department;
      },
      formSubmit() {
        let self = this;

        this.form.users = [];
        if (this.selectedUsers && this.selectedUsers.length) {
          for (var i = 0; i < this.selectedUsers.length; i++) {
            this.form.users.push(this.selectedUsers[i].id);
          }
        }

        if (this.selectedOrganization && this.selectedOrganization.id) {
          this.form.escalation_department_id = this.selectedOrganization.id
        }

        piincHttp.put('incident-categories/' + this.incident.slug, this.form).then(function(response) {
          self.incident = response.data;
          self.showForm = false;
          self.$store.commit('storeUpdateContent', self.incident);
          self.$toastr('success', self.$t('maintenance.incidents.incident_categories.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      cancelForm() {
        this.showForm = false;
      },
      loadUsers(query) {
        let self = this;

        piincHttp.get('users', { params:
          {
            client: this.getClient.id,
            keyword: query ? query : undefined,
            per_page: 50
          }
        }).then(function(response) {
          self.users = response.data.items
        }, function() {});
      },
      loadOrganizations(query) {
        let self = this;

        piincHttp.get('organizations', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined,
            per_page: 50
          }
        }).then(function(response) {
          self.organizations = response.data.items
        }, function() {});
      },
      loadContent() {
        let self = this;
        piincHttp.get('incident-categories/' + this.incident.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.incident = response.data;
        }, function() {});
      }
    },
    created () {
      this.incident = this.object;

      if (this.getClient && this.getClient.slug) {
        this.loadOrganizations()
        this.loadUsers()
      }

      if (this.showOnTask && !this.incident.description) {
        this.showDescriptionInput = true;
      }

      if (this.showOnTask) {
        this.loadContent()
      }

      this.loadGuides('update_escalation_point');

    }
  }
</script>
